import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import FavoriteHeart from '../common/favorite-heart';
import LikeThumb from '../common/like-thumb';
import DislikeThumb from '../common/dislike-thumb';

import { addSceneToDefaultPlaylistAPI, fetchSceneUserDataAPI, removeSceneFromDefaultAPI } from '../../controller/userController';
import ScenesDropDownMenu from '../scenes/ScenesDropDownMenu';

const ActionButtonsContainer = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(15, 118, 110, 0.15);
        transform: translateY(-2px);
    }
`;

const ActionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default function SceneUserData(props) {

    const [userData, setUserData] = useState({
        favorite: false,
        like: false,
        dislike: false,
        time: 0
    })

    const callBack = (data) => {
        console.log(data)
    }

    const fetchSceneUserDataCallback = (data) => {
        setUserData(data)
    }

    useEffect(() => {
        fetchSceneUserDataAPI(props.sceneId, fetchSceneUserDataCallback);
    }, []);

    const favoriteClick = () => {
        if (userData.favorite) {
            removeSceneFromDefaultAPI(props.sceneId, 'favorite', callBack)
            setUserData({ ...userData, favorite: false })
        }
        else {
            addSceneToDefaultPlaylistAPI(props.sceneId, 'favorite', callBack)
            setUserData({ ...userData, favorite: true })
        }
    }

    const likeClick = () => {
        if (userData.like) {
            removeSceneFromDefaultAPI(props.sceneId, 'like', callBack)
            setUserData({ ...userData, like: false })
        }
        else {
            addSceneToDefaultPlaylistAPI(props.sceneId, 'like', callBack)
            setUserData({ ...userData, like: true })
        }
    }

    const dislikeClick = () => {
        if (userData.dislike) {
            removeSceneFromDefaultAPI(props.sceneId, 'dislike', callBack)
            setUserData({ ...userData, dislike: false })
        }
        else {
            addSceneToDefaultPlaylistAPI(props.sceneId, 'dislike', callBack)
            setUserData({ ...userData, dislike: true })
        }
    }

    return (
        <ActionButtonsContainer>
            <ActionWrapper>
                <FavoriteHeart fill={userData.favorite} clickEvent={favoriteClick} />
            </ActionWrapper>
            <ActionWrapper>
                <LikeThumb fill={userData.like} clickEvent={likeClick} />
            </ActionWrapper>
            <ActionWrapper>
                <DislikeThumb fill={userData.dislike} clickEvent={dislikeClick} />
            </ActionWrapper>
            <ActionWrapper>
                <ScenesDropDownMenu type={"scene-view"} sceneId={props.sceneId} />
            </ActionWrapper>
        </ActionButtonsContainer>
    );
}